// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"15":"16acc55d","498":"9407ab2b","513":"0736b9bf","678":"a22d41d0","703":"102c034e","787":"e270daf3"}[chunkId] + ".chunk.js";
};